<form [formGroup]="form" (ngSubmit)="formService.submit()" (keydown)="submitEnter($event)">

    <div class="page_title">
        <div class="row marges">
            <div class="col y_items_center">
                <h1 class="title">{{ (crudService.isCreateAction ? 'channel.add.action.value' : 'channel.update.value') | translate }}</h1>
            </div>

            <div class="col_content y_items_center">

                <!-- Retour -->

                <button class="btn_cta btn_lines btn_little" type="button" (click)="redirectToList()">
                    {{ 'channel.list.back.value' | translate }}
                </button>

                <!-- Enregistrer -->

                <button class="btn_cta btn_little" type="button" (click)="submit(false)">
                    {{ 'form.submit.action.value'|translate }}
                </button>

                @if(crudService.isCreateAction && form.get('enableJS').value) {

                    <!-- Enregistrer et afficher le script -->

                    <button class="btn_cta btn_little" type="button" (click)="submit(true, 'JSIntegration')">
                        {{ 'channel.add.saveAndContinueJs.action.value'|translate }}
                    </button>
                }

                @if(crudService.isCreateAction && form.get('enableApi').value) {

                    <!-- Enregistrer et voir l'implémentation -->

                    <button class="btn_cta btn_little" type="button" (click)="submit(true, 'APIIntegration')">
                        {{ 'channel.add.saveAndContinueApi.action.value'|translate }}
                    </button>
                }

                @if((crudService.isCreateAction && form.get('enableSubDomain').value) || crudService.isUpdateAction) {

                    <!-- Enregistrer et continuer -->

                    <button class="btn_cta btn_little" type="button" (click)="submit(true)">
                        {{ 'channel.add.saveAndContinue.action.value'|translate }}
                    </button>

                }

            </div>
        </div>
    </div>

    <!-- Gestion des onglets -->

    <mat-tab-group #tabGroup>
        <mat-tab [label]="'offer.generalData.value' | translate">
            <ng-container *ngTemplateOutlet="generalData"></ng-container>
        </mat-tab>
        @if(userService.isCurrentUserWithSociety || (userService.isCurrentUserAdmin && isClassicMode && crudService.isUpdateAction)) {
            <mat-tab [label]="'offer.list.selection.value' | translate">
                <ng-container *ngTemplateOutlet="offersSelection"></ng-container>
            </mat-tab>
            @if(crudService.isUpdateAction && channel.enableJS) {
                <mat-tab [label]="'channel.integration.js.value' | translate">
                    <ng-container *ngTemplateOutlet="JSIntegration"></ng-container>
                </mat-tab>
            }
            @if(crudService.isUpdateAction && channel.enableSubDomain) {
                <mat-tab [label]="'channel.integration.subDomain.value' | translate">
                    <ng-container *ngTemplateOutlet="SubdomainIntegration"></ng-container>
                </mat-tab>
            }
            @if(crudService.isUpdateAction && channel.enableApi) {
                <mat-tab [label]="'channel.integration.api.value' | translate">
                    <ng-container *ngTemplateOutlet="APIIntegration"></ng-container>
                </mat-tab>
            }
            @if(crudService.isUpdateAction && channel.enableOrchestra) {
                <mat-tab [label]="'channel.integration.orchestra.value' | translate">
                    <ng-container *ngTemplateOutlet="OrchestraIntegration"></ng-container>
                </mat-tab>
            }
        }
        @if(isOneOfTheseIntegrationModes(['subDomain', 'JS'])) {
            <mat-tab #offerCardPreviewTab [label]="'offer.card.preview.value' | translate">
                <ng-container *ngTemplateOutlet="offerCardPreview; context:{ parentTab: offerCardPreviewTab }"></ng-container>
            </mat-tab>
        }
        @if(isOneOfTheseIntegrationModes(['subDomain', 'JS'])) {
            <mat-tab #offerViewPreviewTab [label]="'offer.view.preview.value' | translate">
                <ng-container *ngTemplateOutlet="offerViewPreview; context:{ parentTab: offerViewPreviewTab }"></ng-container>
            </mat-tab>
        }
    </mat-tab-group>

</form>

<!-- Données générales -->

<ng-template #generalData>

    @if(crudService.isUpdateAction) {

        @if(userService.isCurrentUserAdmin) {

            <div class="row marges">
                <div class="col_12">
                    <div class="deletable_information align_left">
                        <p>
                            <strong>{{ 'channel.owner.value' | translate }} : </strong>
                            <span>{{ channel.society.name }}</span>
                        </p>
                    </div>
                </div>
            </div>
        }

        @if(channel.individualQuota || channel.groupQuota) {
            <div class="row marges">
                <div class="col_12">
                    <div class="deletable_information align_left">
                        <p>
                            <strong>{{ 'channel.individualQuota.max.value' | translate }} :</strong> {{ channel.individualQuota }}
                        </p>
                        <p>
                            <strong>{{ 'channel.groupQuota.max.value' | translate }} :</strong> {{ channel.groupQuota }}
                        </p>
                    </div>
                </div>
            </div>
        }

    }

    <ng-container [formGroup]="form">

        @if(crudService.isCreateAction && isUndefinedMode) {

            <div class="row marges ligne_form">

                <div class="col_12">

                    <!-- Type du canal -->

                    <div class="form-group">
                        <label>{{ 'channel.type.value' | translate}}</label>
                        <div class="radio">
                            <input type="radio" [value]="ChannelMode.Classic" [(ngModel)]="mode" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleChannelType()" class="form-control" id="classicMode">
                            <label for="classicMode">{{'channel.type.classic.value' | translate}}</label>
                        </div>
                        <div class="radio">
                            <input type="radio" [value]="ChannelMode.Restricted" [(ngModel)]="mode" [ngModelOptions]="{standalone: true}" (ngModelChange)="handleChannelType()" class="form-control" id="restrictedMode">
                            <label for="restrictedMode">{{'channel.type.restricted.value' | translate}}</label>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if(crudService.isCreateAction && isDefinedMode && userService.isCurrentUserAdmin) {

            <div class="ligne_form row_marges">
                <div class="col_12">
                    <div class="form-group">
                        <div style="margin-top: 12px">
                            <app-core-select-search [configuration]="societySearchConfiguration" [sourceCallback]="societySearchSourceCallback" [formGroupReference]="form" [formControlNameReference]="'society'" (selectionChange)="handleSociety($event)"></app-core-select-search>
                        </div>
                    </div>
                </div>
            </div>

            <br>
        }

        @if(society) {

            <div class="form_part">

                <p class="title_part">{{'channel.form.generalData.title.web.value' | translate}}</p>

                <div class="row marges ligne_form">

                    <div class="col_6">

                        <!-- Marketplace -->

                        <div class="form-group">
                            <select class="form-control" id="marketplace" formControlName="marketplace" required="required" [compareWith]="compareSocietyWebsite">
                                @for ((societyWebsite of societyWebsites$ | async); track societyWebsite) {
                                    <option [ngValue]="societyWebsite">
                                        {{ societyWebsite.website }}
                                    </option>
                                }
                            </select>
                            <label class="required" for="marketplace">{{ 'channel.restricted.list.fields.marketplace.value' | translate }}</label>
                            @if(form.get('marketplace').errors && (form.get('marketplace').dirty || form.get('marketplace').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('marketplace').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                            @if(crudService.isUpdateAction) {
                                @if(channel.enableJS) {
                                    <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ (isClassicMode ? 'channel.marketplace.update.integration.value' : 'channel.restricted.marketplace.update.integration.value') | translate }}</span>
                                }
                            }
                        </div>

                    </div>

                </div>

                <div class="row marges ligne_form">

                    <div class="col_12">

                        <!-- Mode d'intégration du canal  -->

                        <div class="form-group">
                            <label>{{'channel.integrationMode.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="'subDomain'" formControlName="integrationMode" (change)="updateIntegrationMode()" class="form-control" id="integrationModeDomain">
                                <label for="integrationModeDomain">{{'channel.integrationMode.domain.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="'JS'" formControlName="integrationMode" (change)="updateIntegrationMode()" class="form-control" id="integrationModeJs">
                                <label for="integrationModeJs">{{'channel.integrationMode.js.value' | translate}}</label>
                            </div>
                            @if(integrationModeApiDisplayed) {
                                <div class="radio">
                                    <input type="radio" [value]="'API'" formControlName="integrationMode" (change)="updateIntegrationMode()" class="form-control" id="integrationModeApi" [attr.disabled]="(userService.isCurrentUserWithSociety || !society.channelConfiguration.hasAccessAPI) ? '' : null">
                                    <label for="integrationModeApi">{{'channel.integrationMode.api.value' | translate}}</label>
                                </div>
                            }
                            @if(integrationModeOrchestraDisplayed) {
                                <div class="radio">
                                    <input type="radio" [value]="'orchestra'" formControlName="integrationMode" (change)="updateIntegrationMode()" class="form-control" id="integrationModeOrchestra" [attr.disabled]="(userService.isCurrentUserWithSociety || !(society.channelConfiguration.hasAccessAPI && society.channelConfiguration.allowExternalPayment && society.channelConfiguration.hasAccessCreateChannelOnlineSale && society.channelConfiguration.hasAccessCreateChannelGiftVoucher)) ? '' : null">
                                    <label for="integrationModeOrchestra">{{'channel.integrationMode.orchestra.value' | translate}}</label>
                                </div>
                            }

                            @if(crudService.isCreateAction && userService.isCurrentUserWithSociety) {
                                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.integrationMode.api.create.contactAdmin.value' | translate }}</span>
                            }
                        </div>

                    </div>

                </div>

                @if((isClassicMode && userService.isCurrentUserAdmin) || (crudService.isCreateAction && ((isClassicMode && (societyHasRole('ROLE_OFFER_DISTRIBUTOR') || societyHasAllOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']))) || isRestrictedMode)) || (crudService.isUpdateAction && societyHasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']))) {

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Distributeur du canal -->

                            <div class="form-group">
                                <label>{{'channel.distributor.question.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="isDistributor" class="form-control" id="isDistributorYes">
                                    <label for="isDistributorYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="isDistributor" class="form-control" id="isDistributorNo">
                                    <label for="isDistributorNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>

                                @if(crudService.isCreateAction && userService.isCurrentUserWithSociety) {
                                    <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ ((isClassicMode ? 'channel.distributor.' : 'channel.restricted.distributor.') + (form.get('isDistributor').value ? 'checked' : 'unchecked') + '.description.value') | translate }}</span>
                                }

                                @if(crudService.isUpdateAction && userService.isCurrentUserWithSociety) {
                                    <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ ('channel.distributor.' + (form.get('isDistributor').value ? 'checked' : 'unchecked') + '.description.value') | translate }}</span>
                                }

                                @if(form.get('isDistributor').errors && (form.get('isDistributor').dirty || form.get('isDistributor').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('isDistributor').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                }

                @if(crudService.isCreateAction && form.get('enableSubDomain').value) {

                    <div class="row marges ligne_form">
                        <div class="col_6">

                            <!-- Domaine -->

                            <div class="form-group">
                                <div class="row">
                                    <div class="col_content addon_input y_items_center">
                                        <span>https://</span>
                                    </div>
                                    <div class="col content_input">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="subDomain" id="subDomain">
                                        <label for="subDomain">{{'channel.integrationMode.subdomain.value' | translate}}</label>
                                    </div>
                                    <div class="col_content addon_input y_items_center">
                                        <span>{{subDomainSuffix}}</span>
                                    </div>
                                </div>
                                @if(form.get('subDomain').errors && (form.get('subDomain').dirty || form.get('subDomain').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('subDomain').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(form.get('subDomain').errors.isNotValid) {
                                                <div>{{ 'channel.integrationMode.subdomain.error.value' | translate }}</div>
                                            }
                                            @if(form.get('subDomain').errors.isPatternInvalid) {
                                                <div>{{ 'channel.integrationMode.subdomain.invalidPattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>

                        </div>
                    </div>
                }

                @if((crudService.isCreateAction && form.get('enableJS').value) || (crudService.isUpdateAction && channel.enableJS)) {

                    <div class="row marges ligne_form">
                        <div class="col_8">

                            <!-- Url canonical -->

                            <div class="form-group">
                                <div class="row">
                                    @if((crudService.isCreateAction && marketplace) || crudService.isUpdateAction) {
                                        <div class="col_content addon_input y_items_center">
                                            <span>{{ marketplace }}</span>
                                        </div>
                                    }
                                    <div class="col content_input">
                                        <input type="text" value="/" placeholder=" " class="form-control" formControlName="canonicalUrl" id="canonicalUrl">
                                        <label for="canonicalUrl">{{'channel.canonicalUrl.value' | translate}}</label>
                                        @if(crudService.isUpdateAction) {
                                            <mat-icon class="tooltip_icon_edit" (click)="editCanonicalUrl()">edit</mat-icon>
                                        }
                                    </div>
                                </div>
                                @if(form.get('canonicalUrl').errors && (form.get('canonicalUrl').dirty || form.get('canonicalUrl').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('canonicalUrl').errors.isRequired) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(form.get('canonicalUrl').errors.isPatternInvalid) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                                <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.canonicalUrl.info.value' | translate }}<br/>{{ 'channel.canonicalUrl.update.value' | translate }}</span>
                            </div>

                        </div>
                    </div>
                }

                @if((crudService.isCreateAction && form.get('enableApi').value) || (crudService.isUpdateAction && isMine && channel.enableApi)) {

                    <div class="row marges ligne_form">

                        <div class="col_6">

                            <!-- Adresses IPs -->

                            <div class="form-group">
                                <mat-select formControlName="allowedIps" multiple [compareWith]="compareSocietyIp">
                                    @for (societyIp of societyIps; track societyIp) {
                                        <mat-option [value]="societyIp">{{ societyIp.address | translate }}</mat-option>
                                    }
                                </mat-select>
                                <mat-label class="required">{{ 'ipAddress.plural.allowed.value' | translate }}</mat-label>
                                @if(form.get('allowedIps').invalid) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('allowedIps').errors.isRequired) {
                                                <div>{{ 'ipAddress.selection.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>

                        </div>

                    </div>

                    @if(crudService.isCreateAction && userService.isCurrentUserAdmin) {

                        <div class="row marges ligne_form">
                            <div class="col_12">

                                <div class="form-group">
                                    <label>{{'payment.external.value' | translate}}</label>
                                    <div class="radio">
                                        <input type="radio" [value]="true" formControlName="enableExternalPayment" class="form-control" id="enableExternalPaymentYes">
                                        <label for="enableExternalPaymentYes">{{'form.user.fields.yes.value' | translate}}</label>
                                    </div>
                                    <div class="radio">
                                        <input type="radio" [value]="false" formControlName="enableExternalPayment" class="form-control" id="enableExternalPaymentNo">
                                        <label for="enableExternalPaymentNo">{{'form.user.fields.no.value' | translate}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if(form.get('enableExternalPayment').value) {

                            <div class="ligne_form">
                                <div class="col_12">
                                    <div class="form-group">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                        <span>{{ 'channel.marketing.configuration.api.externalPayment.help.value' | translate }}</span>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        }
                    }
                }

                @if(crudService.isCreateAction) {

                    <div class="row marges ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                @if(form.get('enableSubDomain').value) {
                                    <div class="ck-content" [innerHTML]="('channel.integrationMode.domain.explain.' + (societyHasRole('ROLE_OFFER_CREATOR') ? 'offerCreator.' : '') + 'value') | translate:{ subDomainSuffix: subDomainSuffix }"></div>
                                }
                                @if(form.get('enableJS').value) {
                                    <div class="ck-content" [innerHTML]="('channel.integrationMode.js.explain.' + (societyHasRole('ROLE_OFFER_CREATOR') ? 'offerCreator.' : '') + 'value') | translate"></div>
                                }
                            </div>
                        </div>
                    </div>

                    @if(isRestrictedMode) {

                        <div class="row marges ligne_form">
                            <div class="col_6">

                                <!-- Quota individuel -->

                                <div class="form-group">
                                    <input type="number" min="0" value="" placeholder=" " class="form-control" formControlName="individualQuota" id="individualQuota" required="required">
                                    <label for="individualQuota">{{'channel.restricted.list.fields.individualQuota.value' | translate}}</label>
                                    @if(form.get('individualQuota').errors && (form.get('individualQuota').dirty || form.get('individualQuota').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(form.get('individualQuota').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(form.get('individualQuota').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>
                            <div class="col_6">

                                <!-- Quota groupe -->

                                <div class="form-group">
                                    <input type="number" min="0" value="" placeholder=" " class="form-control" formControlName="groupQuota" id="groupQuota" required="required">
                                    <label for="groupQuota">{{'channel.restricted.list.fields.groupQuota.value' | translate}}</label>
                                    @if(form.get('groupQuota').errors && (form.get('groupQuota').dirty || form.get('groupQuota').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(form.get('groupQuota').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                                @if(form.get('groupQuota').errors.pattern) {
                                                    <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>

                            </div>
                        </div>
                    }
                }

                @if(societyHasRole('ROLE_OFFER_CREATOR') && isOneOfTheseIntegrationModes(['JS'])) {

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Référencer les offres du canal -->

                            <div class="form-group">
                                <label>{{'channel.referenced.question.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="referenced" class="form-control" id="referencedYes">
                                    <label for="referencedYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="referenced" class="form-control" id="referencedNo">
                                    <label for="referencedNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>

                                @if(userService.isCurrentUserWithSociety) {
                                    <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ ('channel.referenced.description.' + (form.get('referenced').value ? 'checked' : 'unchecked') + '.value') | translate }}</span>
                                }

                                @if(form.get('referenced').errors && (form.get('referenced').dirty || form.get('referenced').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('referenced').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="row marges ligne_form">
                    <div class="col_12">

                        <!-- Activer le canal -->

                        <div class="form-group">
                            <label>{{'channel.enable.question.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" [value]="true" formControlName="enable" class="form-control" id="enableYes">
                                <label for="enableYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" [value]="false" formControlName="enable" class="form-control" id="enableNo">
                                <label for="enableNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                            @if(!isActivationAllowed) {
                                <span class="message-help error"><mat-icon class="tooltip_icon">info</mat-icon>{{ (isStarterSubscription ? 'channel.enable.premiumRequired.description.value' : 'channel.enable.help.disable.value') | translate }}</span>
                            }
                            @if(form.get('enable').errors && (form.get('enable').dirty || form.get('enable').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('enable').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">
                    <div class="col_12 col_md_6">

                        <!-- Commentaire -->

                        <div class="form-group">
                            <textarea placeholder=" " class="form-control" formControlName="comment" id="comment"></textarea>
                            <label for="comment">{{'comment.internal.value' | translate}}</label>
                        </div>

                    </div>
                </div>

            </div>

            <div class="form_part">

                <p class="title_part">{{ 'channel.form.generalData.title.display.value' | translate }}</p>

                <div class="ligne_form row marges">

                    <div class="col_12">

                        <ng-container formArrayName="translations">

                            <ng-container [formGroupName]="translationBuilder.indexAsString(0)">
                                <div class="row marges ligne_form">

                                    <div class="col_6">

                                        <!-- Référénce -->

                                        <div class="form-group">
                                            <input type="text" value="" placeholder=" " class="form-control" formControlName="name" id="name" required="required">
                                            <label for="name">{{ 'channel.name.value' | translate }}</label>
                                            @if(getTranslation(0).get('name').errors && (getTranslation(0).get('name').dirty || getTranslation(0).get('name').touched)) {
                                                <mat-error>
                                                    <div class="invalid-feedback">
                                                        @if(getTranslation(0).get('name').errors.required) {
                                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                        }
                                                    </div>
                                                </mat-error>
                                            }
                                        </div>
                                    </div>

                                    @if(isOneOfTheseIntegrationModes(['subDomain', 'JS', 'API'])) {

                                        <div class="col_6">

                                            <!-- Titre -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="title" id="title">
                                                <label for="name">{{ 'channel.title.value' | translate }}</label>
                                                <div class="form-group col_content y_items_center">
                                                    <span class="message-help">
                                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                                        {{ 'channel.title.info.value' | translate }}
                                                    </span>
                                                </div>
                                                @if(getTranslation(0).get('title').errors && (getTranslation(0).get('title').dirty || getTranslation(0).get('title').touched)) {
                                                    <mat-error>
                                                        <div class="invalid-feedback">
                                                            @if(getTranslation(0).get('title').errors.required) {
                                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                            }
                                                        </div>
                                                    </mat-error>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>

                                @if(isOneOfTheseIntegrationModes(['subDomain', 'JS', 'API'])) {

                                    <div class="row marges ligne_form">
                                        <div class="col_12">

                                            <!-- Description -->

                                            <div class="form-group">
                                                <input type="text" value="" placeholder=" " class="form-control" formControlName="description" id="description">
                                                <label for="description">{{'description.value' | translate}}</label>
                                                <div class="form-group col_content y_items_center">
                                                    <span class="message-help">
                                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                                        {{ 'description.info.value' | translate }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                }
                            </ng-container>

                        </ng-container>

                    </div>
                </div>

                <div class="row marges ligne_form">

                    @if(isOneOfTheseIntegrationModes(['subDomain', 'JS'])) {

                        <div class="col_4">

                            <div class="form-group add_picture big">
                                <div class="row">
                                    <div class="form-group">
                                        <label>{{'channel.logo.value' | translate}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col_content">
                                        <form-field-image [config]="logoConfig" [form]="logoImageControl"></form-field-image>
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.logo.info.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col_4">
                            <div class="form-group add_picture big">
                                <div class="row">
                                    <div class="form-group">
                                        <label>{{'channel.banner.value' | translate}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col_content">
                                        <form-field-image [config]="imageConfig" [form]="pictureImageControl"></form-field-image>
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.banner.info.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    @if(isOneOfTheseIntegrationModes(['subDomain'])) {
                        <div class="col_4">
                            <div class="form-group add_picture big">
                                <div class="row">
                                    <div class="form-group">
                                        <label>{{'channel.favicon.value' | translate}}</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col_content">
                                        <form-field-file [config]="faviconConfig" [form]="form" [file]="form.get('favicon').value"></form-field-file>
                                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.favicon.info.value' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div class="row marges ligne_form">
                    <div class="col_6">
                        @if(hasImage(form.get('logo'))) {
                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="logoUrl" id="logoUrl">
                                <label for="logoUrl">{{ 'channel.logo.url.value' | translate }}</label>
                                @if(form.get('logoUrl').errors && (form.get('logoUrl').dirty || form.get('logoUrl').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('logoUrl').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        }
                    </div>
                    <div class="col_6">
                        @if(hasImage(form.get('picture'))) {
                            <div class="form-group">
                                <input type="text" value="" placeholder=" " class="form-control" formControlName="pictureUrl" id="pictureUrl">
                                <label for="pictureUrl">{{ 'channel.banner.url.value' | translate }}</label>
                                @if(form.get('pictureUrl').errors && (form.get('pictureUrl').dirty || form.get('pictureUrl').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('pictureUrl').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        }
                    </div>
                </div>

            </div>

            <div class="form_part">

                @if(isOneOfTheseIntegrationModes(['subDomain', 'JS', 'API'])) {

                    <p class="title_part">{{ 'channel.form.generalData.title.displayOption.value' | translate }}</p>

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Affichage du moteur de recherche -->

                            <div class="form-group">
                                <label>{{'channel.searchEngine.display.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="searchEngine" class="form-control" id="searchEngineYes">
                                    <label for="searchEngineYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="searchEngine" class="form-control" id="searchEngineNo">
                                    <label for="searchEngineNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                @if(form.get('searchEngine').errors && (form.get('searchEngine').dirty || form.get('searchEngine').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('searchEngine').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Affichage de la carte -->

                            <div class="form-group">
                                <label>{{'channel.map.display.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="allowMap" class="form-control" id="allowMapYes">
                                    <label for="allowMapYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="allowMap" class="form-control" id="allowMapNo">
                                    <label for="allowMapNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                @if(form.get('allowMap').errors && (form.get('allowMap').dirty || form.get('allowMap').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('allowMap').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>

                    <div class="row marges ligne_form">
                        <div class="col_12">

                            <!-- Affichage du créateur d'offre -->
                            <div class="form-group">
                                <label>{{ 'channel.displayCo.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="displayCo" class="form-control" id="displayCoYes">
                                    <label for="displayCoYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="displayCo" class="form-control" id="displayCoNo">
                                    <label for="displayCoNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                @if(form.get('displayCo').errors && (form.get('displayCo').dirty || form.get('displayCo').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('displayCo').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                }

                <div class="row marges ligne_form">

                    <div class="col_12">

                        <!-- Afficher des informations d’accès en train -->

                        <div class="form-group">
                            <label>{{ 'access.information.trainStation.display.action.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" name="display-trainStation" [value]="true" class="form-control" id="displayTrainStationYes" [checked]="isSelectedAllowedTransport('train-station')" (change)="handleAllowedTransportSelection('train-station', true)">
                                <label for="displayTrainStationYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" name="display-trainStation" [value]="false" class="form-control" id="displayTrainStationNo" [checked]="!isSelectedAllowedTransport('train-station')" (change)="handleAllowedTransportSelection('train-station', false)">
                                <label for="displayTrainStationNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">

                    <div class="col_12">

                        <!-- Afficher les informations d’accès en avion -->

                        <div class="form-group">
                            <label>{{ 'access.information.airport.display.action.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" name="display-airport" [value]="true" class="form-control" id="displayAirportYes" [checked]="isSelectedAllowedTransport('airport')" (change)="handleAllowedTransportSelection('airport', true)">
                                <label for="displayAirportYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" name="display-airport" [value]="false" class="form-control" id="displayAirportNo" [checked]="!isSelectedAllowedTransport('airport')" (change)="handleAllowedTransportSelection('airport', false)">
                                <label for="displayAirportNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">

                    <div class="col_12">

                        <!-- Afficher un bouton personnalisé -->

                        <div class="form-group">
                            <label>{{ 'channel.hasExternalLink.value' | translate}}</label>
                            <div class="radio">
                                <input type="radio" formControlName="hasExternalLink" [value]="true" class="form-control" id="hasExternalLinkYes">
                                <label for="hasExternalLinkYes">{{'form.user.fields.yes.value' | translate}}</label>
                            </div>
                            <div class="radio">
                                <input type="radio" formControlName="hasExternalLink" [value]="false" class="form-control" id="hasExternalLinkNo">
                                <label for="hasExternalLinkNo">{{'form.user.fields.no.value' | translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>

                @if(form.get('hasExternalLink').value) {

                    <div class="row marges ligne_form">

                        <!-- Label du lien externe -->

                        <div class="col_6">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="externalLinkLabel" id="externalLinkLabel" required="required">
                                        <label for="externalLinkLabel">{{'channel.externalLinkLabel.value' | translate}}</label>
                                    </div>
                                </div>
                                @if(form.get('externalLinkLabel').errors && (form.get('externalLinkLabel').dirty || form.get('externalLinkLabel').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('externalLinkLabel').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                        <!-- Url du lien externe -->

                        <div class="col_6">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col">
                                        <input type="text" value="" placeholder=" " class="form-control" formControlName="externalLinkUrl" id="externalLinkUrl" required="required">
                                        <label for="externalLinkUrl">{{'channel.externalLinkUrl.value' | translate}}</label>
                                    </div>
                                </div>
                                @if(form.get('externalLinkUrl').errors && (form.get('externalLinkUrl').dirty || form.get('externalLinkUrl').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('externalLinkUrl').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                            @if(form.get('externalLinkUrl').errors.pattern) {
                                                <div>{{ 'form.control.error.pattern.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>
                        </div>

                    </div>
                }

                @if(isOneOfTheseIntegrationModes(['subDomain', 'JS'])) {

                    <ng-container formArrayName="style">

                        <!-- Prévisualisations -->

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{ 'channel.style.title.value' | translate}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <app-select-search [config]="fontFieldConfig" [value]="form.controls['style'].get('font').value" [form]="form" (valueChange)="changeFont($event)"></app-select-search>
                            </div>
                            <div class="col_6">
                                <!-- colorBackground -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" [value]="colorBackground" (colorPickerChange)="updateColorField($event,'colorBackground')"  [(colorPicker)]="colorBackground" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorBackground" id="colorBackground">
                                    <label for="colorBackground">{{'channel.fields.colorBackground.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorBackground"></span>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <!-- colorTitle -->
                                <div class="form-group color">
                                    <input type="text" readonly (colorPickerChange)="updateColorField($event,'colorTitle')" autocomplete="off" [value]="colorTitle" [(colorPicker)]="colorTitle" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorTitle" id="colorTitle">
                                    <label for="colorTitle">{{'channel.fields.colorTitle.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorTitle"></span>
                                </div>
                            </div>
                            <div class="col_6">
                                <!-- colorHighlighting -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" [value]="colorHighlighting" (colorPickerChange)="updateColorField($event,'colorHighlighting')"  [(colorPicker)]="colorHighlighting" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorHighlighting" id="colorHighlighting">
                                    <label for="colorHighlighting">{{'channel.fields.colorHighlighting.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorHighlighting"></span>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <!-- colorSubTitle -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" (colorPickerChange)="updateColorField($event,'colorSubTitle')" [value]="colorSubTitle" [(colorPicker)]="colorSubTitle" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorSubTitle" id="colorSubTitle">
                                    <label for="colorSubTitle">{{'channel.fields.colorSubTitle.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorSubTitle"></span>
                                </div>
                            </div>
                            <div class="col_6">
                                <!-- colorTextButton -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" [value]="colorTextButton" (colorPickerChange)="updateColorField($event,'colorTextButton')"  [(colorPicker)]="colorTextButton" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorTextButton" id="colorTextButton">
                                    <label for="colorTextButton">{{'channel.fields.colorTextButton.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorTextButton"></span>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">
                            <div class="col_6">
                                <!-- colorDescription -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" (colorPickerChange)="updateColorField($event,'colorDescription')" [value]="colorDescription" [(colorPicker)]="colorDescription" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorDescription" id="colorDescription">
                                    <label for="colorDescription">{{'channel.fields.colorDescription.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorDescription"></span>
                                </div>
                            </div>
                            <div class="col_6">
                                <!-- colorBackgroundButton -->
                                <div class="form-group color">
                                    <input type="text" readonly autocomplete="off" (colorPickerChange)="updateColorField($event,'colorBackgroundButton')" [value]="colorBackgroundButton" [(colorPicker)]="colorBackgroundButton" [cpWidth]="'300px'" [cpHeight]="'400px'" placeholder=" " class="form-control" formControlName="colorBackgroundButton" id="colorBackgroundButton">
                                    <label for="colorBackgroundButton">{{'channel.fields.colorBackgroundButton.value' | translate}}</label>
                                    <span class="show_color" [style.background]="colorBackgroundButton"></span>
                                </div>
                            </div>
                        </div>

                    </ng-container>

                }

                @if(!isOneOfTheseIntegrationModes(['orchestra'])) {

                    <ng-container formArrayName="sort">

                        <!-- Tri des offres -->

                        <div class="row marges ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <label>{{ 'channel.sort.title.value' | translate}}</label>
                                </div>
                            </div>
                        </div>

                        <div class="row marges ligne_form">

                            <div class="col_6">
                                <div class="form-group">
                                    <select class="form-control" id="orderBy" formControlName="orderBy">
                                        <option value=""></option>
                                        @for ((orderBy of sortsOrderBy$ | async); track orderBy) {
                                            <option [value]="orderBy">{{ orderByLabel(orderBy) }}</option>
                                        }
                                    </select>
                                    <label class="required" for="orderBy">{{ 'channel.fields.sort.orderBy.value' | translate }}</label>
                                    @if(sortForm.get('orderBy').errors && (sortForm.get('orderBy').dirty || sortForm.get('orderBy').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(sortForm.get('orderBy').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>

                            <div class="col_6">
                                <div class="form-group">
                                    <select class="form-control" id="operator" formControlName="operator">
                                        <option value=""></option>
                                        @for ((operator of sortsOperators$ | async); track operator) {
                                            <option [value]="operator">{{ operatorLabel(operator) }}</option>
                                        }
                                    </select>
                                    <label class="required" for="operator">{{ 'channel.fields.sort.operator.value' | translate }}</label>
                                    @if(sortForm.get('operator').errors && (sortForm.get('operator').dirty || sortForm.get('operator').touched)) {
                                        <mat-error>
                                            <div class="invalid-feedback">
                                                @if(sortForm.get('operator').errors.required) {
                                                    <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                }
                                            </div>
                                        </mat-error>
                                    }
                                </div>
                            </div>
                        </div>

                    </ng-container>
                }

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">
                            <label>{{ 'channel.locale.currency.title.value' | translate}}</label>
                        </div>
                    </div>
                </div>

                <div class="row marges ligne_form">

                    @if(crudService.isCreateAction || (crudService.isUpdateAction && isClassicMode)) {

                        <div class="col_6">

                            <!-- Langue -->

                            <div class="ligne_form row marges">
                                <div class="col_12">
                                    <div class="form-group">
                                        <select class="form-control" id="locale" formControlName="locale" required="required" (change)="changeLocale()">
                                            <option value=""></option>
                                            @for ((locale of locales$ | async); track locale) {
                                                <option [value]="locale.id">{{ locale.label | translate }}</option>
                                            }
                                        </select>
                                        <label class="required" for="locale">{{ 'locale.value' | translate }}</label>
                                        @if(form.get('locale').errors && (form.get('locale').dirty || form.get('locale').touched)) {
                                            <mat-error>
                                                <div class="invalid-feedback">
                                                    @if(form.get('locale').errors.required) {
                                                        <div>{{ 'form.control.error.required.value' | translate }}</div>
                                                    }
                                                </div>
                                            </mat-error>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div class="col_6">

                        <!-- Sélection de la devise -->

                        <div class="form-group">
                            <select class="form-control" id="currency" formControlName="currency" required="required">
                                <option value=""></option>
                                @for (currency of currencies; track currency) {
                                    <option [value]="currency.id">
                                        {{ translationService.getFallbackTranslation(currency.translations).label }} ({{ currency.code }})
                                    </option>
                                }
                            </select>
                            <label class="required" for="currency">{{ 'currency.value' | translate }}</label>
                            @if(form.get('currency').errors && (form.get('currency').dirty || form.get('currency').touched)) {
                                <mat-error>
                                    <div class="invalid-feedback">
                                        @if(form.get('currency').errors.required) {
                                            <div>{{ 'form.control.error.required.value' | translate }}</div>
                                        }
                                    </div>
                                </mat-error>
                            }
                        </div>

                    </div>

                </div>

            </div>

            <div class="form_part">

                <p class="title_part">{{'channel.form.generalData.title.marketing.value' | translate}}</p>

                <!-- Options de commercialisation -->

                @if(marketingRestrictionFromCurrencyDisplayed) {

                    <div class="ligne_form">
                        <div class="col_12">
                            <div class="form-group">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                        <span>{{ 'channel.marketing.restriction.fromCurrency.warning.value' | translate }}</span>
                                    </span>
                            </div>
                        </div>
                    </div>
                }

                @if(userService.isCurrentUserWithSociety && form.get('integrationMode').value !== 'orchestra') {

                    @if(marketingConfigurationDisplayed) {

                        <div class="ligne_form">
                            <div class="col_12">
                                <div class="form-group">
                                    <span class="message-help">
                                        <mat-icon class="tooltip_icon">info</mat-icon>
                                        <span>{{ 'channel.marketing.configuration.startFromPrice.warning.value' | translate }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    }

                    @if((!isAllowGiftVoucher && societyHasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) || form.get('allowOnlineSale').value) {

                        <div class="ligne_form">
                            <div class="col_12">

                                <div class="form-group">
                                    @if(!isAllowGiftVoucher && societyHasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])) {
                                        <span class="message-help">
                                            <mat-icon class="tooltip_icon">info</mat-icon>
                                            <span>{{ 'channel.marketing.configuration.serviceRequired.description_1.value' | translate }} <a [routerLink]="['/account/service/list']">{{ 'user.account.services.value' | translate }}</a> {{ 'channel.marketing.configuration.serviceRequired.description_2.value' | translate }} <a [routerLink]="['/account/service/list']" [queryParams]="{ targetTab: 'document' }">{{ 'document.plural.yours.value' | translate }}</a> {{ 'channel.marketing.configuration.serviceRequired.description_3.value' | translate }}</span>
                                        </span>
                                    }
                                </div>

                            </div>
                        </div>
                    }
                }

                <div class="row marges ligne_form">
                    <div class="col_12">
                        <div class="form-group">

                            @if(allowOnlineSaleDisplayed) {

                                <div class="checkbox min-size">
                                    <input type="checkbox" id="allowOnlineSale" formControlName="allowOnlineSale">
                                    <label for="allowOnlineSale">{{ 'offer.onlineSale.value' | translate }}</label>
                                </div>
                            }

                            @if(allowBookingDisplayed) {

                                <div class="checkbox min-size">
                                    <input type="checkbox" id="allowBooking" formControlName="allowBooking">
                                    <label for="allowBooking">{{ 'booking.type.booking.value' | translate }}</label>
                                </div>
                            }

                            @if(allowRequestDisplayed) {

                                <div class="checkbox min-size">
                                    <input type="checkbox" id="allowRequest" formControlName="allowRequest">
                                    <label for="allowRequest">{{ 'booking.type.request.value' | translate }}</label>
                                </div>
                            }

                            @if(allowGiftVoucherDisplayed) {

                                <div class="checkbox min-size">
                                    <input type="checkbox" id="allowGiftVoucher" formControlName="allowGiftVoucher">
                                    <label for="allowGiftVoucher">{{ (societyHasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) ? 'giftVoucher.value' : 'giftVoucher.eligibleOffer.value') | translate }}</label>
                                </div>
                            }

                            @if(allowShowcaseDisplayed) {

                                <div class="checkbox min-size">
                                    <input type="checkbox" id="allowShowcase" formControlName="allowShowcase">
                                    <label for="allowShowcase">{{ 'channel.showcase.value' | translate }}</label>
                                </div>
                            }

                        </div>

                        @if(form.errors && form.errors.isMarketingConfigurationRequired) {

                            <div class="form-group">
                                <mat-error>
                                    <div class="invalid-feedback">
                                        <div>{{ 'channel.marketing.configuration.required' | translate }}</div>
                                    </div>
                                </mat-error>
                            </div>
                        }

                    </div>
                </div>

                @if(form.get('allowShowcase').value) {

                    <div class="row marges ligne_form">
                        <div #showcaseReference class="col">

                            <!-- Afficher le tarif “à partir de” dans la miniature de l’offre -->

                            <div class="form-group indent_left">
                                <label>{{ 'channel.showcase.displayStartFromPrice.action.value' | translate}}</label>
                                <div class="radio">
                                    <input type="radio" [value]="true" formControlName="displayStartFromPrice" class="form-control" id="displayStartFromPriceYes">
                                    <label for="displayStartFromPriceYes">{{'form.user.fields.yes.value' | translate}}</label>
                                </div>
                                <div class="radio">
                                    <input type="radio" [value]="false" formControlName="displayStartFromPrice" class="form-control" id="displayStartFromPriceNo">
                                    <label for="displayStartFromPriceNo">{{'form.user.fields.no.value' | translate}}</label>
                                </div>
                                @if(form.get('displayStartFromPrice').errors && (form.get('displayStartFromPrice').dirty || form.get('displayStartFromPrice').touched)) {
                                    <mat-error>
                                        <div class="invalid-feedback">
                                            @if(form.get('displayStartFromPrice').errors.required) {
                                                <div>{{ 'form.control.error.required.value' | translate }}</div>
                                            }
                                        </div>
                                    </mat-error>
                                }
                            </div>

                        </div>
                    </div>
                }

            </div>
        }

    </ng-container>
</ng-template>

<!-- Sélection des offres -->

<ng-template #offersSelection>

    <div [formGroup]="form" class="tab_content_overflow">
        <div class="row marges">

            @if(userService.isCurrentUserAdmin) {

                <div class="col_12">
                    <div class="form-group">
                        <span class="message-help"><mat-icon class="tooltip_icon">info</mat-icon>{{ 'channel.offer.selection.admin.help.value' | translate }}</span>
                    </div>
                </div>
            }

            <div class="col y_items_center">

                @if(offerSearchService.selectedOffers.value.length) {
                    <div class="selected_offers">

                        <span>{{ 'offer.list.selected.value' | translate }} :</span>
                        <ul>
                            @for (offer of offerSearchService.selectedOffers.value; track offer) {
                                <li>{{ translationService.getFallbackTranslation(offer.translations).name }}@if(userService.isCurrentUserAdmin) { - {{ offer.society.name }} }</li>
                            }
                        </ul>
                    </div>
                }
            </div>

            @if(userService.isCurrentUserWithSociety) {

                @if(offerSearchService.selectedOffers.value.length) {
                    <div class="col_content y_items_center">
                        <button type="button" class="btn_cta btn_little" (click)="deselectOffer() ">{{ 'channel.button.noSelectOffer.value' | translate}}</button>
                    </div>
                }
            }

        </div>

        @if(userService.isCurrentUserWithSociety) {

            <app-core-offer-search
                [user]="society.admin"
                [society]="society"
                [mode]="'channel'"
                [locale]="form.get('locale')"
                [referenced]="form.get('referenced')"
                [allowBooking]="form.get('allowBooking')"
                [allowRequest]="form.get('allowRequest')"
                [allowOnlineSale]="form.get('allowOnlineSale')"
                [allowGiftVoucher]="form.get('allowGiftVoucher')"
                [integrationMode]="form.get('integrationMode')"
            ></app-core-offer-search>
        }

    </div>

</ng-template>

<ng-template #JSIntegration>

    <div class="ck-content">

        <h3 style="font-weight: bold">{{ 'channel.help.jsIntegration.title.value' | translate }}</h3>

        <p>- {{ 'channel.help.jsIntegration.description.start.value' | translate }} <span class="modify" [innerText]="'<body>'"></span>{{ 'channel.help.jsIntegration.description.end.value' | translate }}</p>

        <div class="copy-content" (click)="copyJSIntegrationWCContent()" title="{{ 'channel.help.jsIntegration.copy.value' | translate }}">

            <pre><<span>tywin-channel</span><span class="no_modify">&nbsp;token="{{ channel.tokenJs }}</span>" <span class="modify">base-url="{{ canonicalUrl }}</span>"><<span>/tywin-channel</span>></pre>

        </div>

        <div class="form-group">

            <span class="message-help">
                <mat-icon class="tooltip_icon">info</mat-icon>
                <div [innerHTML]="('channel.help.jsIntegration.help.token.value' | translate)"></div>
            </span>

            <span class="message-help">
                <mat-icon class="tooltip_icon">info</mat-icon>
                <div [innerHTML]="(('channel.help.jsIntegration.help.baseUrl.value' | translate: {marketplace : marketplace}) | safeHtml)"></div>
            </span>

        </div>

        <p>- {{ 'channel.help.jsIntegration.script.value' | translate }} <span class="modify" [innerText]="'<body>'"></span> :</p>

        <div class="copy-content" (click)="copyJSIntegrationSourceContent()" title="{{'channel.help.jsIntegration.copy.value' | translate }}">

            <pre><span class="modify" [innerText]="JSIntegrationSourceTag"></span></pre>

        </div>

        @if(channel.referenced) {

            <h3 style="font-weight: bold">{{ 'channel.help.jsIntegration.referenced.title.value' | translate }}</h3>

            <div class="ligne_form row marges">
                <div class="col_12">
                    <p [innerHTML]="'channel.help.jsIntegration.referenced.content.value' | translate"></p>
                </div>
            </div>

            <div class="row marges">
                <div class="col_content">
                    <button class="btn_cta btn_little" type="button" (click)="downloadTechnicalDocumentation()">
                        {{ 'channel.help.jsIntegration.referenced.button.value' | translate }}
                    </button>
                </div>
            </div>
        }
    </div>

</ng-template>

<ng-template #SubdomainIntegration>

    <span style="padding-top: 10px;">{{ 'channel.help.subDomain.description.value' | translate }} <a href="{{ subDomainIntegrationLink }}" target="_blank"><span style="padding-top: 10px; color: orange; font-weight: bold" [innerText]="subDomainIntegrationLink"></span></a></span>

</ng-template>

<ng-template #APIIntegration>

    <div class="ck-content">

        <h3 style="font-weight: bold">{{ 'channel.help.apiIntegration.title.value' | translate }}</h3>

        <p>- {{ 'channel.id.value' | translate }} : <span class="modify">{{ channel.id }}</span></p>

        <div class="row">
            <div class="col_content">
                <p>- {{ 'ipAddress.plural.selected.value' | translate }} :&nbsp;</p>
            </div>
            <div class="col">
                @for (allowedIp of allowedIps; track $index) {
                    <p style="margin-bottom: 4px;">
                        <span class="modify">{{ allowedIp }}</span>
                    </p>
                }
            </div>
        </div>

        <div class="subscription_information">
            <p [innerHTML]="('channel.help.apiIntegration.description.value' | translate)|safeHtml"></p>
        </div>
    </div>

</ng-template>

<ng-template #OrchestraIntegration>

    <div class="ck-content">

        <h3 style="font-weight: bold">{{ 'channel.help.orchestraIntegration.title.value' | translate }} :</h3>

        <div class="subscription_information">
            <p [innerHTML]="'channel.help.orchestraIntegration.description.value' | translate: { id: channel.id }"></p>
        </div>

    </div>

</ng-template>

<ng-template #offerCardPreview let-parentTab="parentTab">

    @if(parentTab.isActive) {

        <app-core-channel-offer-card-preview [styleForm]="styleForm"></app-core-channel-offer-card-preview>
    }

</ng-template>

<ng-template #offerViewPreview let-parentTab="parentTab">

    @if(parentTab.isActive) {

        <app-core-channel-offer-view-preview [styleForm]="styleForm"></app-core-channel-offer-view-preview>
    }

</ng-template>
